import React from 'react';
import { ArrowLeft, Search, Heart, Activity, Droplets, Droplet, Shield, Syringe, Package2, TrendingUp } from 'lucide-react';
import { useApp } from '@/context/AppContext';
import { PRODUCTS, formatINR } from '@/data/mockData';

const CAT_ICON_MAP = {
  'Fertility':          { Icon: Heart,      color: '#E91E63', bg: '#FFF0F3' },
  "Women's Wellness":   { Icon: Activity,   color: '#9C27B0', bg: '#F3E5F5' },
  'Hormonal Support':   { Icon: Droplets,   color: '#3F51B5', bg: '#E8EAF6' },
  'Gynae Hematinics':   { Icon: Droplet,    color: '#F44336', bg: '#FFEBEE' },
  'Bone & Supportive':  { Icon: Shield,     color: '#388E3C', bg: '#E8F5E9' },
  'Injectable Range':   { Icon: Syringe,    color: '#FF5722', bg: '#FBE9E7' },
  'Miscellaneous':      { Icon: Package2,   color: '#607D8B', bg: '#ECEFF1' },
  'Top Movers':         { Icon: TrendingUp, color: '#FF9800', bg: '#FFF3E0' },
};

function getProducts(category) {
  if (category === 'Frequent Orders')
    return PRODUCTS.filter(p => p.invoiceCount >= 7).sort((a, b) => b.invoiceCount - a.invoiceCount);
  if (category === 'All' || category === 'Most Selling')
    return PRODUCTS;
  return PRODUCTS.filter(p => p.category === category);
}

export default function CategoryProductsScreen() {
  const { goBack, navigate, screenParams } = useApp();
  const { category } = screenParams || {};
  const products = getProducts(category);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-white px-4 pt-5 pb-3 border-b border-gray-100">
        <div className="flex items-center justify-between">
          <button
            data-testid="cat-products-back"
            onClick={goBack}
            className="w-9 h-9 flex items-center justify-center tap-scale"
          >
            <ArrowLeft size={22} color="#374151" />
          </button>
          <h1
            className="font-black tracking-widest uppercase text-gray-900 text-center flex-1"
            style={{ fontSize: '13px', letterSpacing: '0.1em' }}
          >
            {category || 'Products'}
          </h1>
          <button className="w-9 h-9 flex items-center justify-center tap-scale">
            <Search size={20} color="#2563EB" />
          </button>
        </div>
      </div>

      {/* Product grid — 2 columns */}
      <div className="px-4 pt-4 pb-8">
        {products.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-20 text-gray-400">
            <Package2 size={48} color="#D1D5DB" className="mb-3" />
            <div className="font-semibold">No products in this category</div>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3">
            {products.map(p => {
              const info = CAT_ICON_MAP[p.category] || { Icon: Package2, color: '#607D8B', bg: '#ECEFF1' };
              const { Icon } = info;
              return (
                <div
                  key={p.id}
                  data-testid={`cat-product-${p.id}`}
                  className="bg-white rounded-2xl overflow-hidden"
                  style={{ boxShadow: '0 1px 6px rgba(0,0,0,0.08)', border: '1px solid #F3F4F6' }}
                >
                  {/* Image placeholder */}
                  <div className="h-36 flex items-center justify-center" style={{ background: info.bg }}>
                    <Icon size={56} color={info.color} strokeWidth={1.5} />
                  </div>
                  <div className="p-3">
                    <div className="font-bold text-sm text-gray-800 leading-tight mb-0.5">
                      {p.name} ({p.pack})
                    </div>
                    <div className="text-xs text-gray-400 mb-3">M.R.P ₹{formatINR(p.mrp)}</div>
                    <button
                      data-testid={`request-btn-${p.id}`}
                      onClick={() => navigate('PRODUCT_REQUEST', { product: p })}
                      className="w-full text-white text-sm font-bold py-2 rounded-xl tap-scale"
                      style={{ background: '#FF5722' }}
                    >
                      Request
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
